var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.25a3.754 3.754 0 0 1 3.75 3.704c-.01.075-.017.151-.02.23L16.2 6.1l.869.303A2.495 2.495 0 0 1 18.75 8.75c0 1.38-1.12 2.5-2.5 2.5H3.75c-1.378 0-2.5-1.12-2.5-2.5a2.505 2.505 0 0 1 2.46-2.5c.06.009.12.016.182.02l.95.062.312-.897A2.495 2.495 0 0 1 7.5 3.75c.122 0 .256.015.437.046l.875.158.436-.775c.669-1.19 1.914-1.929 3.252-1.929zm0-1.25c-1.873 0-3.485 1.042-4.342 2.566A3.756 3.756 0 0 0 7.5 2.5a3.737 3.737 0 0 0-3.527 2.522C3.9 5.017 3.827 5 3.75 5a3.751 3.751 0 0 0 0 7.5h12.5c2.07 0 3.75-1.68 3.75-3.75a3.739 3.739 0 0 0-2.522-3.528c.002-.076.022-.146.022-.222a5 5 0 0 0-5-5z",
    fill: "currentColor",
    fillRule: "nonzero",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.379acb78c1d2ba09020c9f3e1ed6db43.svg";
export { ForwardRef as ReactComponent };